import * as React from "react";
import { NumericFormat } from "react-number-format";

import { MaxLengthMessage } from "./Common/MaxLenghtMessage";
import { IInputFieldProps } from "./IInputFieldProps";
import "./inputfield.scss";

export interface InputAmountFieldProps extends IInputFieldProps<HTMLInputElement> {
  icon?: "search" | string;
  value?: string;
  children?: React.ReactNode;
  maxLength?: number;
  showMaxLengthMessage?: boolean;
  disabled?: boolean;
  isInvalid?: boolean;
  ariaLabelledby?: string;
  ariaDescribedBy?: string;
  decimalScale?: number;
  showIsValidCheckmark?: boolean;
}

export const InputAmountField = (props: InputAmountFieldProps) => {
  const genericIcon = props.icon && props.icon !== "search" ? <span className={props.icon}></span> : "";
  const icon = <>{props.icon === "search" ? <span className={`${props.icon}-icon`}> </span> : genericIcon}</>;
  const warningMessage = props.showMaxLengthMessage && props.maxLength && (
    <MaxLengthMessage id={props.id} value={props.value} maxLength={props.maxLength} />
  );

  let input = (
    <>
      {icon}
      <NumericFormat
        thousandSeparator={"."}
        decimalSeparator={","}
        className={`form-control form-control--amount ${props.className ?? ""}`}
        aria-labelledby={props.ariaLabelledby}
        aria-describedby={props.ariaDescribedBy}
        onChange={props.onChange}
        onBlur={props.onBlur}
        maxLength={props.maxLength}
        value={props.value || ""}
        disabled={props.disabled}
        placeholder={props.placeholder}
        style={{ display: props.displayStyle }}
        decimalScale={props.decimalScale}
        {...(props.id ? { id: props.id } : {})}
        {...(props.name ? { name: props.name } : {})}
      />
    </>
  );

  if (props.showIsValidCheckmark) {
    input = wrapInputInGroup(
      <>
        {input}
        <div className={!props.isInvalid && props.value ? "form-control--is-valid-indicator" : ""}></div>
      </>
    );
  } else if (props.icon && props.icon !== "search") {
    input = wrapInputInGroup(input);
  }
  return (
    <>
      {input}
      {warningMessage}
    </>
  );
};

const wrapInputInGroup = (input: JSX.Element) => {
  return <div className="input-group">{input}</div>;
};
